import Urls from "./Urls.js";

const ua = navigator.userAgent;

/**
 * Gibt eine Reihe von Check-Funktionen und boolschen Flags zurück, um Informationen über das aktuelle Device zu erhalten
 */
const DeviceDetection = {

    iphone: /iPhone/i.test(ua),
    ipod: /iPod/i.test(ua),
    ipad: /iPad/i.test(ua),
    blackberry: /BlackBerry/i.test(ua),
    playbook: /PlayBook/i.test(ua),
    android: /Android/i.test(ua),
    macOS: /Mac OS X/i.test(ua),
    win: /Windows/i.test(ua),
    mac: /Macintosh/i.test(ua),
    linux: /(Linux|X11)/i.test(ua),
    wphone: /(Windows Phone OS|Windows CE|Windows Mobile)/i.test(ua),
    mobile: /Mobile/i.test(ua),
    // http://mojosunite.com/tablet-user-agent-strings
    androidTablet: /(GT-P1000|SGH-T849|SHW-M180S)/i.test(ua),
    tabletPc: /Tablet PC/i.test(ua),
    palmDevice: /(PalmOS|PalmSource| Pre\/)/i.test(ua),
    kindle: /(Kindle)/i.test(ua),
    otherMobileHints: /(Opera Mini|IEMobile|SonyEricsson|smartphone)/i.test(ua),
    chrome: /chrome/i.test(ua) && /Google/i.test(navigator.vendor),
    safari: /safari/i.test(ua) && /Apple/i.test(navigator.vendor),
    webkit: /AppleWebKit/i.test(ua),
    ie: /MSIE/i.test(ua),
    ie11: !!window.MSInputMethodContext && !!document.documentMode,
    edge: /Edge\/\d+/i.test(ua),
    firefox: /firefox/i.test(ua),

    isTouchDevice: function() {
        return DeviceDetection.iphone || DeviceDetection.ipod || DeviceDetection.ipad;
    },
    isApple: function() {
        return DeviceDetection.iphone || DeviceDetection.ipod || DeviceDetection.ipad || DeviceDetection.macOS  || DeviceDetection.mac;
    },
    isBlackberry: function() {
        return DeviceDetection.blackberry;
    },
    isAndroid: function() {
        return DeviceDetection.android;
    },
    isTablet: function() {
        return DeviceDetection.ipad || DeviceDetection.playbook || DeviceDetection.androidTablet || DeviceDetection.kindle;
    },
    isDesktop: function() {
        return !DeviceDetection.isTouchDevice() && !DeviceDetection.isSmartPhone() && !DeviceDetection.isTablet()
    },
    isSmartPhone: function() {
        return (DeviceDetection.mobile || DeviceDetection.blackberry || DeviceDetection.palmDevice || DeviceDetection.otherMobileHints) && !DeviceDetection.isTablet() && !DeviceDetection.ipod;
    },
    isIOS: function() {
        return DeviceDetection.iphone || DeviceDetection.ipod || DeviceDetection.ipad;
    },
    isLowPerformanceDevice: function() {
        // TODO hier besserer Ansatz? Ist halt sehr von der speziellen Szene und den Modellen / Browser abhängig
        return false;
    },
    isWebGLAvailable:function () {
        try {
            var canvas = document.createElement( 'canvas' );
            return !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );
        } catch ( e ) {
            return false;
        }
    },

    isIE: function() {
        return DeviceDetection.ie || DeviceDetection.ie11;
    },

    setCssClassOnBody: function() {
        if (DeviceDetection.isIOS()) {
            $('body').addClass('ua-ios');
        }
    },

    isSmartphoneDisplay: (() => {
        // Tablets sollen false und Smartphones true ergeben. Die Seite soll zudem responsive sein.
        // CSS und JS soll gleich sein. Nach eingehendem Einlesen in die Materie:
        // Einzige brauchbare Einheit für Media Queries sind px (Safari hat Bugs bei em).
        // Die kürzeste Seite des kleinsten Tabletts (600px) ist größer als die kürzeste Seite des größten
        // Handies (https://www.mydevice.io/#compare-devices).
        const w = $(window);
        return Math.min(w.outerWidth(), w.outerHeight()) < 600;
    })(),

}

DeviceDetection.setCssClassOnBody();

export default DeviceDetection;

